module.exports = __webpack_public_path__ + "static/media/thumbnail_advincula-for-use.20ba5e1f.jpg";